import { tieneAccesoPlus } from './planGating';
import { PRODUCTOS_PLUS } from './productosPlus';

export const FARMACOS_GRATIS = Object.freeze(['paracetamol', 'metamizol', 'ceftriaxona', 'omeprazol', 'salbutamol']);
export const ESCALAS_GRATIS = Object.freeze(['glasgow', 'braden', 'eva']);

// Recibe el perfil REAL, no perfilParaMundo: la enciclopedia es compartida.
// Conserva TENS, grants legacy, trial y transición/acceso abierto existentes.
export function tieneEnciclopediaCompleta(profile, ahora = Date.now()) {
  if (!profile || profile.sin_perfil) return false;
  if (profile.rol === 'tens') return true;
  if (profile.plan === 'premium' && Object.hasOwn(PRODUCTOS_PLUS, profile.premium_product || '')
      && (!profile.premium_until || Date.parse(profile.premium_until) > ahora)) return true;
  return tieneAccesoPlus(profile, ahora);
}

export function puedeAbrirRecurso(tipo, id, completo = false) {
  const seleccion = tipo === 'farmaco' ? FARMACOS_GRATIS : tipo === 'escala' ? ESCALAS_GRATIS : [];
  return completo || seleccion.includes(id);
}
